"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports._shouldValidateOnSignIn = exports.getErrorMessage = exports.handleValidation = exports.handleKeyDown = exports.handleChange = void 0;

var _react = _interopRequireDefault(require("react"));

var _validation = require("./validation");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
// utils

/* ++++++++++ --------------- HELPERS --------------- ++++++++++ */


var isValid = function isValid(props, fieldValue) {
  var specificValidation = _validation.validation[props.name];
  var isValid = true;

  if (props.required) {
    switch (props.type) {
      case 'select':
        isValid = fieldValue !== '';
        break;

      case 'checkbox':
        isValid = true;
        break;

      case 'radio':
        isValid = true;
        break;

      default:
        isValid = specificValidationExists(props.name) ? specificValidation.test.test(fieldValue) : true;
        break;
    }
  }

  return isValid;
};

var specificValidationExists = function specificValidationExists(name) {
  return _validation.validation[name] !== undefined;
};
/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */


var handleChange = function handleChange(props, e) {
  if (props.handleChange) props.handleChange(e); //IF TYPE IS OF CHECKBOX WE WILL SET VALUE TO EQUAL THE OPPOSITE OF ITS CURRENT CHECKED VALUE

  var value = props.type === 'checkbox' ? !props.checked : e.target.value;
  props.setFormFieldValue(props.formName, props.name, value);
};

exports.handleChange = handleChange;

var handleKeyDown = function handleKeyDown(props, e) {
  handleValidation(props, e.target.value);
  if (props.handleKeyDown) props.handleKeyDown(e, isValid(props, e.target.value));
};

exports.handleKeyDown = handleKeyDown;

var handleValidation = function handleValidation(props, fieldValue) {
  var validationStatus = isValid(props, fieldValue);
  if (props.valid !== validationStatus && !props.formDisabled) props.setFieldValidation(props.formName, props.name, validationStatus);
};

exports.handleValidation = handleValidation;

var getErrorMessage = function getErrorMessage(name) {
  var specificValidation = _validation.validation[name];
  return specificValidationExists(name) ? specificValidation.message : _validation.validation['general'].message;
}; // Validate email:
// - on change only if it vas previously invalidated. This will make UX a bit better when user corrects invalid email.
// - on 3rd party password manager pre-filling credentials. This will validate the form automatically


exports.getErrorMessage = getErrorMessage;

var _shouldValidateOnSignIn = function _shouldValidateOnSignIn(props, fieldValue) {
  return props.type === 'email' && (props.valid === false || props.valid === null && isValid(props, fieldValue));
};

exports._shouldValidateOnSignIn = _shouldValidateOnSignIn;